import { useEffect, useState } from "react";
import { getUsersURL } from "../../utils/ConstantsURL";

export const useGetUsers = (token, refresh) => {
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(false);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        let response = await fetch(getUsersURL(), {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        });

        let data = await response.json();
        if (response.ok) {
          setUsers(data.users);
        } else {
          throw new Error(data.message);
        }
      } catch (error) {
        console.error("Error al obtener los usuarios:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [token, refresh]);

  return { users, loading };
};
